import OrgInfo from './OrgInfo/OrgInfo';
import { OrgUserManagement } from './OrgUserManagement';

const OrgInfoAndUsers: React.FC = () => (
  <div
    className="flex w-full flex-col gap-4"
    data-testid="org-info-users-container"
  >
    <OrgInfo />
    <OrgUserManagement />
  </div>
);

export default OrgInfoAndUsers;
